import { render, staticRenderFns } from "./settings-header.vue?vue&type=template&id=1342d4cb"
import script from "./settings-header.vue?vue&type=script&lang=js"
export * from "./settings-header.vue?vue&type=script&lang=js"
import style0 from "./settings-header.vue?vue&type=style&index=0&id=1342d4cb&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports